/**
 * Formats a duration in seconds as m:ss (e.g. 95 -> "1:35") for video
 * metadata display. Returns '' when the duration is unknown.
 */
export function formatDuration(seconds: number | undefined): string {
  if (seconds === undefined || seconds === null) return '';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}
